<template>
  <div class="card dashboard-bookings-calendar-accordion-item mb-1">
    <div class="card-header p-0" id="headingOne">
      <h5 class="mb-0">
        <button
          class="btn btn-link text-left w-100"
          data-toggle="collapse"
          :data-target="`#${id}`"
          :aria-expanded="index === 0 ? true : false"
          :aria-controls="id"
        >
          <strong>
            Boeking:
            <template v-if="isActivity"
              >{{ startTime }} - {{ endTime }}</template
            >
            <template v-if="isRoom">{{ startDate }} - {{ endDate }}</template>
          </strong>

          <template v-if="booking.bookable">
            &nbsp; - {{ booking.bookable.title }}
          </template>
        </button>
      </h5>
    </div>

    <div
      :id="id"
      class="collapse"
      :class="{ show: index === 0 }"
      aria-labelledby="headingOne"
      :data-parent="`#${baseKey}`"
    >
      <div class="card-body p-0">
        <div class="dashboard-bookings-calendar-accordion-item__details">
          <div v-if="booking?.bookable?.owner">
            <i class="las la-hashtag mr-2" />

            <span>
              <strong class="d-block"> Boekingsnummer </strong>
              #{{ booking.id }}
            </span>
          </div>

          <div v-if="booking?.bookable?.owner">
            <i class="las la-hotel mr-2" />

            <span>
              <strong class="d-block"> Champagnehuis/Accommodatie </strong>
              {{ booking.bookable.owner.name }}
            </span>
          </div>

          <div class="d-flex">
            <i class="lar la-calendar mr-2" />

            <div>
                <strong
                    class="d-block dashboard-bookings-calendar-accordion-item__date-string"
                >{{ startDate }}</strong>
                <span v-if="isActivity">{{ startTime }}</span>
                <span v-if="isRoom">
                    <span
                        class="dashboard-bookings-calendar-accordion-item__date-string"
                    >{{ startDate }}</span>
                -
                    <span
                        class="dashboard-bookings-calendar-accordion-item__date-string"
                    >{{ endDate }}</span>
                </span>
            </div>
          </div>

          <div>
            <i class="la la-user mr-2" />

            <span>
              <strong class="d-block"> Gasten </strong>
              {{ guest }}
            </span>
          </div>

          <div>
            <i class="la la-users mr-2" />

            <div>
              <strong class="d-block"> Personen </strong>

              <ul
                v-for="(group, index) in booking.groups"
                :key="index"
                class="m-0 p-0"
              >
                <li>{{ group.group }}: {{ group.amount }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AccordionItem",
  props: {
    item: {
      type: Object,
    },
    baseKey: {},
    index: {},
  },
  data() {
    return {
      id: `${this.baseKey}-${this.index}`,
    };
  },
  computed: {
    booking() {
      return this.item.customData.booking;
    },
    guest() {
      return this.booking?.details?.main_guest_fullname;
    },
    title() {
      const bookableTitle = this.booking?.bookable?.title;

      let title = `${this.guest}, ${bookableTitle}`;

      if (!title) {
        return "Geen activiteit/kamer bekend";
      }

      title = title.length > 16 ? title.substring(0, 16).concat("...") : title;

      return title;
    },
    localizedStartDate() {
      return moment(this.booking.start_date).locale("nl");
    },
    localizedEndDate() {
      return moment(this.booking.end_date).locale("nl");
    },
    startDate() {
      return this.localizedStartDate.format("dddd, DD MMMM YYYY");
    },
    endDate() {
      return this.localizedStartDate.format("dddd, DD MMMM YYYY");
    },
    startTime() {
      return this.localizedStartDate.format("HH:mm");
    },
    endTime() {
      return this.localizedEndDate.format("HH:mm");
    },
    isActivity() {
      return this.booking.type === "activity";
    },
    isRoom() {
      return this.booking.type === "room";
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-bookings-calendar-accordion-item {
  &__title {
    font-size: 10px;
    font-weight: 600;
    color: var(--secondary);
    display: inline-block;
    line-height: 0.9rem;
    white-space: nowrap;
  }

  &__date {
    display: inline-block;
    font-size: 10px;
    color: var(--secondary);
    right: 0;
    position: absolute;
    background: #fff;
    padding-left: 0.25rem;
  }

    &__date-string {
        &:first-letter {
            text-transform: uppercase;
        }
    }

  &__details {
    padding: 1rem 1.25rem;
    font-size: 12px;

    h4 {
      font-size: 14px;
      font-weight: 400;
    }

    ul {
      list-style-type: none;
    }

    > div {
      display: flex;

      &:not(:last-child) {
        margin-bottom: 1.25rem;
      }
    }
  }
}
</style>
